/**
 * Filename: home.js
 * Home page
 * Component path
 * IconBoxed  'componenet/iconboxes.js'
 * Charts compoenent from 'compoenent/charts'
 * Table from 'containers/table.js'
 */

import React, {Component} from 'react';
import SidebarMenuRouters from "../../routers/routers.js";
import Header from '../../containers/header.js';
import ActionTools from '../../containers/actionTools.js';
import {Redirect} from 'react-router';
import {ROL} from '../../utils/constants';

class DirectionHome extends Component {
  constructor(props) {
    super(props);
    var userData = JSON.parse(localStorage.getItem("userData"));
    this.state = {userData: userData}
  }

  render() {
    var result;

    if (this.state.userData.rol === ROL.OPERATION.url) {
      result = <div>
        <SidebarMenuRouters profile="/operation-home/" place={this.props.match.params.vp}/>
        <Header userName={this.state.userData.name}/>
        <ActionTools profile={'/profile-operation/'} place={this.props.match.params.vp}/>
      </div>
    } else {
      result = <Redirect to={"/"}/>
    }

    return (
      <div>
        {result}
      </div>
    );
  }
}

export default DirectionHome;



// WEBPACK FOOTER //
// ./src/scene/operation/home.js